import { mergeClasses } from "@fluentui/react-components";
import { SkillListProps } from "./types";
import { SkillsDefaults } from "@/common/constants/skills";
import { useCommonStyle } from "@/common/style/commonStyle";

export const SkillList = (props: SkillListProps) => {
	const commonStyle = useCommonStyle();

	return (
		<div className={props.containerClass}>
			{props.skillList?.length
				? props.skillList?.map((skill, index) => (
						<span
							key={skill.id}
							className={mergeClasses(
								skill.weight === SkillsDefaults.MaxSkillLevel
									? commonStyle.semiBold
									: "",
								props.textClass ?? ""
							)}
						>
							{skill.name}
							{index < (props.skillList?.length ?? 0) - 1 ? ", " : ""}
						</span>
					))
				: "-"}
		</div>
	);
};
